import { createContext } from "react";

const Context = createContext();
console.log(Context);
export default Context;
